export default __webpack_public_path__ + "static/media/generator.82a6f0cb.png";